import { RadioGroup } from "devextreme-react";
import { Button } from "devextreme-react/Button";
import { RadioGroupRef } from "devextreme-react/cjs/radio-group";
import notify from "../../lib/notify";
import { useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { acceptRegulation } from "../../api/auth";
import { useAuth } from "../../contexts/auth";

export default function ProcessingOfEmailAddressAcceptance() {
  const { t } = useTranslation();
  const { user, setRegulationAccepted, signOut } = useAuth();
  const radioGroupRef = useRef<RadioGroupRef>(null);

  const [accepted, setAccepted] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const handleSaveButtonClick = useCallback(async () => {
    if (!accepted) {
      signOut();
    } else {
      setIsLoading(true);

      try {
        await acceptRegulation("ProcessingOfEmailAddress");
        setRegulationAccepted("ProcessingOfEmailAddress");
      } catch (error) {
        notify(
          error instanceof Error
            ? error.message
            : t("common.unknownErrorOccurred"),
          "error",
          5000,
        );
      } finally {
        setIsLoading(false);
      }
    }
  }, [accepted, setRegulationAccepted, signOut, t]);

  return (
    <div className="p-3 flex flex-col space-y-4 whitespace-pre-wrap text-justify">
      <div className="text-center font-bold">
        ZGODA NA PRZETWARZANIE ADRESU E-MAIL
      </div>
      <div>
        <table className="border border-solid border-collapse">
          <tbody>
            <tr>
              <td className="p-2 border border-solid bg-gray-200">
                Imię i nazwisko
              </td>
              <td className="p-2 border border-solid">{`${user?.firstName} ${user?.lastName}`}</td>
            </tr>
            <tr>
              <td className="p-2 border border-solid bg-gray-200">
                Adres e-mail
              </td>
              <td className="p-2 border border-solid">{user?.email}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        Oświadczam, że wyrażam zgodę na wykorzystanie podanego powyżej adresu
        e-mail do celów:
        <ol>
          <li>logowania do aplikacji Invenio HR,</li>
          <li>
            komunikacji związanej z dostępem do systemu (np. reset hasła,
            powiadomienia systemowe),
          </li>
          <li>
            otrzymania linku aktywacyjnego oraz instrukcji pierwszego logowania.
          </li>
        </ol>
      </div>
      <div>* proszę zaznaczyć:</div>
      <div className="flex items-center gap-3">
        <RadioGroup
          ref={radioGroupRef}
          items={[
            {
              value: false,
              label: t("no"),
            },
            {
              value: true,
              label: t("yes"),
            },
          ]}
          valueExpr="value"
          displayExpr="label"
          defaultValue={true}
          layout="horizontal"
          disabled={isLoading}
          onValueChanged={(event) => setAccepted(event.value)}
        />
        <Button
          stylingMode="contained"
          type="default"
          text={t("save")}
          onClick={handleSaveButtonClick}
          disabled={isLoading}
        />
      </div>
      <div>
        <span className="font-bold">
          Zgoda może być w dowolnym czasie odwołana
        </span>{" "}
        - poprzez wysłanie e-mail do InvenioQD na adres tychy@invenio.pl -
        jednak będzie się to wiązało z brakiem możliwości korzystania z
        aplikacji.
      </div>
    </div>
  );
}
